export const parentHierarchyBreadcrumbStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		overflow: 'hidden'
	},

	separator: {
		flexShrink: 0,
		color: 'text.secondary'
	},

	item: (maxWidth: number | null) => ({
		flex: '1 1 0',
		minWidth: 0,
		overflow: 'hidden',
		...(maxWidth != null ? { maxWidth: `${maxWidth}px` } : {})
	}),

	link: {
		display: 'block',
		fontSize: '1rem',
		fontWeight: 400,
		lineHeight: 1.4,
		letterSpacing: '0.17px'
	}
};
